// ThankYou.js
import React from 'react';
import { useParams } from 'react-router-dom';
import './ThankYou.css'; // Optional CSS file for styling

const ThankYou = () => {
  const { customerId } = useParams(); // in case you want to reference customerId later

  return (
    <div className="thank-you-container">
      <p style={{ textAlign: 'left' }}>
        <strong>
          Thank you for your payment.<br /><br />
          Payments do not show up immediately in your tax payment history and may not appear until after the next business day.<br /><br />
          Please do not attempt to re-pay this bill as it will result in a duplicate charge.
        </strong>
      </p>
    </div>
  );
};

export default ThankYou;